export default "__VITE_ASSET__e5adfc4b__"